import { PackageRareClasses } from './classes/PackageRareClasses';
import { actionRegistry, conditionRegistry, registry, traitRegistry } from '../../registry/Registry';
import { RareSkeletons } from './skeletons/RareSkeletons';
import { RareConditions } from './conditions/RareConditions';
import { RareComponents } from './components/RareComponents';
import { RareActions } from './actions/RareActions';
import { RareTraits } from './traits/RareTraits';
export class PackageRare {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    actions = new RareActions(actionRegistry);
    classes = new PackageRareClasses();
    components = new RareComponents();
    conditions = new RareConditions(conditionRegistry);
    skeletons = new RareSkeletons(registry.skeletonRegistry);
    traits = new RareTraits(traitRegistry);
}
